/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import useSourceScreen from '../../../hooks/useSourceScreen';
import {
  getEmptyRequiredFields,
  inputFields,
} from '../../../utils/helper';
import RippleButton from '../../HomePage/HeroSection/RippleButton';
import {
  getCityStateData,
  updateUserProfile,
} from '../../../redux/slices/accountInfoSlice/actions';
import styles from './myprofile.module.scss';
import SuccessIcon from '../../../assets/images/course-dashboard/tabs/Success.svg';
import { useMoengageEventTracker } from '../../../hooks/useMoengage';

function MyProfile() {
  const dispatch = useDispatch();
  const screen = useSourceScreen();
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);
  const [showErrorMessage, setShowErrorMessage] = React.useState(false);
  const [isEmailHovered, setIsEmailHovered] = React.useState(false);
  const [isMobileHovered, setIsMobileHovered] = React.useState(false);
  const trackMoengageEvent = useMoengageEventTracker();
  const { authUser, isProfileLoaded, authState } = useSelector((state) => ({
    authUser: state?.auth?.authUser,
    isProfileLoaded: state.auth?.isProfileLoaded,
    authState: state.auth?.isAuthState,
  }));
  const {
    register,
    setError,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      firstName: authUser?.first_name || authUser?.firstName || '',
      mobile: authUser?.mobile_number || authUser?.mobileNumber || '',
      email: authUser?.email || '',
      address: authUser?.address || '',
      city: authUser?.city || '',
      state: authUser?.state || '',
      pincode: authUser?.pincode || '',
      area: authUser?.area || '',
      landmark: authUser?.landmark || '',
    },
  });

  React.useEffect(() => {
    if ((authState === 'login' || authState === 'signup') && isProfileLoaded) {
      setValue('firstName', authUser?.first_name || authUser?.firstName || '');
      setValue('mobile', authUser?.mobile_number || authUser?.mobileNumber || '');
      setValue('email', authUser?.email || '');
      setValue('address', authUser?.address || '');
      setValue('city', authUser?.city || '');
      setValue('state', authUser?.state || '');
      setValue('pincode', authUser?.pincode || '');
      setValue('area', authUser?.area || '');
      setValue('landmark', authUser?.landmark || '');
    }
  }, [isProfileLoaded]);

  React.useEffect(() => {
    if (sessionStorage.getItem('MoeFlag')) {
      const screenArray = sessionStorage.getItem('sourceScreen_Array')?.split(',');
      try {
        trackMoengageEvent('account_info_tapped', {
          screen_source: screenArray?.[screenArray?.length - 1] || screen,
          position: 'top',
        });
        sessionStorage.removeItem('MoeFlag');
      } catch (error) {
        // Handle error
      }
    }
  }, []);

  const handleChange = (keyName) => {
    setError(keyName, {});
    clearErrors(keyName);
    setError('form', {});
  };
  const setPincodeError = (val) => {
    setError('pincode', {
      type: 'manual',
      message: val?.length < 6 ? 'Pincode must be 6 digits' : 'Pincode must be an integer',
    });
  };
  const handlePinCodeChange = async (e) => {
    const pinCode = e.target.value;
    setError('form', {});
      if (/^\d{6}$/.test(pinCode)) {
        try {
          const res = await dispatch(
            getCityStateData({ pincode: pinCode }),
          ).unwrap();
          const { district, state } = res.data;
          setValue('city', district);
          setValue('state', state);
          clearErrors();
        } catch (error) {
          setError('pincode', {
            type: 'manual',
            message: error || error?.message,
          });
          setValue('city', '');
          setValue('state', '');
        }
      } else {
        setPincodeError(pinCode);
      setValue('city', '');
      setValue('state', '');
    }
  };
  const hideMessage = (type) => {
    setTimeout(() => {
      if (type === 'success') {
        setShowSuccessMessage(false);
      } else if (type === 'error') {
        setShowErrorMessage(false);
      }
    }, 3000);
  };

  React.useEffect(() => {
    if (showSuccessMessage) {
      hideMessage('success');
    }
  }, [showSuccessMessage]);

  React.useEffect(() => {
    if (showErrorMessage) {
      hideMessage('error');
    }
  }, [showErrorMessage]);

  const onSubmit = async () => {
    const data = getValues();
    const payload = {
      source_screen: 'profile',
      is_profile_updated: 'no',
    };
    clearErrors('pincode');
    const errorMessageObj = getEmptyRequiredFields(data);
    if (errorMessageObj && (/^\d{6}$/.test(data?.pincode))) {
      try {
        const res = await dispatch(
          updateUserProfile({
            name: data?.firstName,
            address: data?.address,
            city: data?.city,
            state: data?.city,
            pinCode: data?.pincode,
            landmark: data?.landmark || '',
            area: data?.area,
          }),
        ).unwrap();
        if (res?.success) {
          setShowSuccessMessage(true);
          trackMoengageEvent('profile_update_tapped', {
            ...payload,
            error_msg: res?.msg,
          });
        }
      } catch (error) {
        const newErroMessage = error || error?.message;
        setError('form', { type: 'manual', message: newErroMessage });
        trackMoengageEvent('profile_update_tapped', {
          ...payload,
          error_msg: newErroMessage,
        });
        setShowErrorMessage(true);
      }
    } else {
      setError('form', {});
      clearErrors();
      let firstEmptyFieldIndex = -1;
      Object.keys(data)?.forEach((key, index) => {
        if (!data[key]) {
          setError(key, { type: 'manual', message: `${key} is required` });
          if (firstEmptyFieldIndex === -1) {
            firstEmptyFieldIndex = index;
            trackMoengageEvent('profile_update_tapped', {
              ...payload,
              error_msg: `${key} is required`,
            });
          }
        } else if (!(/^\d{6}$/.test(data?.pincode))) {
          setPincodeError(data?.pincode);
          setValue('city', '');
          setValue('state', '');
        } else {
          setError('form', {});
          clearErrors(data[key]);
        }
      });
    }
  };

  const handleMouseOver = (fieldName) => {
    if (fieldName === 'email') {
      setIsEmailHovered(true);
      setIsMobileHovered(false);
    } else if (fieldName === 'mobile') {
      setIsMobileHovered(true);
      setIsEmailHovered(false);
    }
  };

  const handleMouseOut = () => {
    setIsEmailHovered(false);
    setIsMobileHovered(false);
  };

  return (
    <div className={styles.myProfileOuterWrapper}>
      <form>
        <div className={styles.myProfileInnerWrapper}>
          <div className={styles.gridWrapper}>
            {inputFields?.map((field) => (
              <div className={styles.gridItem} key={field?.name}>
                <label className={styles.formLabel}>{field?.label}</label>
                <div className={styles.formWrapper}>
                  <input
                    {...register(field?.name, {
                      required: (field?.name !== 'landmark' && !field?.disabled),
                    })}
                    className={classNames(
                      styles.formInput,
                      { [styles.formInputActive]: field?.disabled },
                      { [styles.formInputErrors]: (field?.name !== 'landmark' &&
                       !field?.disabled && errors?.[field?.name]?.message) },
                    )}
                    placeholder={field?.placeholder}
                    onInput={(e) => {
                      if (field?.name === 'pincode') {
                        e.target.value = e.target.value?.replace(/[^0-9]/g, '');
                        e.target.value = e.target.value?.slice(0, 6);
                      }
                    }}
                    maxLength={field?.maxLength}
                    disabled={field?.disabled}
                    onChange={
                      field?.name === 'pincode'
                        ? handlePinCodeChange
                        : () => handleChange(field?.name)
                    }
                    onMouseOver={() => handleMouseOver(field?.name)}
                    onMouseOut={handleMouseOut}
                  />
                </div>
                {(field?.name !== 'landmark' &&
                  !field?.disabled &&
                  errors?.[field?.name]?.message) && (
                    <div className={styles.errorMessage}>
                      {field?.name === 'pincode'
                        ? errors?.[field?.name]?.message
                        : field?.errorMessage}
                    </div>
                  )}
                {((field?.name === 'mobile' && isMobileHovered) ||
                  (field?.name === 'email' && isEmailHovered)) && (
                  <div className={styles.emailHoverText}>
                    You can update {field?.name} from Account
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className={styles?.btnWrapper}>
            <RippleButton
              onClick={() => {
                onSubmit();
              }}
              type="button"
              className={styles.btnPrimary}
              rippleColor="#fff"
              opacity={0.52}
            >
              Update Profile
            </RippleButton>
            {(errors?.form?.message && showErrorMessage) && (
              <div className={styles.formErrorMessage}>
                <FontAwesomeIcon
                  icon={faXmark}
                  className={styles.crossMarkIcon}
                />
                {errors?.form?.message}
              </div>
            )}
          </div>
        </div>

        {showSuccessMessage && (
          <div className={styles.formSuccessMessage}>
            <SuccessIcon className={styles.notesDeleteIcon} />
            <span className={classNames(styles.noteDeleteText, styles.addedToText)}>
              Your profile has been updated successfully.
            </span>
          </div>
        )}
      </form>
    </div>
  );
}

export default MyProfile;
